export const foodCalculators = [

  // pizza
  {
    name: "حاسبة البيتزا",
    link: "/calculator/ar/pizza/",
    description:
      "حاسبة البيتزا الاحترافية - احسب كمية الدقيق، الماء، الخميرة، والملح اللازمة لعمل عجينة البيتزا المثالية. تحكم في نسبة الترطيب، عدد الكرات، ووزن الكرة الواحدة.",
    showMain: true,
  },
  // 
  {
    name: "حاسبة الآيس كريم",
    link: "/calculator/ar/ice-cream/",
    description:
      "احسب كمية المكونات اللازمة لصنع الآيس كريم اللذيذ في المنزل. حاسبة الآيس كريم تساعدك في تحديد كمية الحليب، السكر، الكريمة، والنكهات المطلوبة بناءً على عدد الحصص التي ترغب في إعدادها.",
    showMain: true,
  },
  //  cake-pan-conversion
  {
    name: "حاسبة تحويل مقاسات قوالب الكيك",
    link: "/calculator/ar/cake-pan-conversion/",
    description:
      "احسب تحويل مقاسات قوالب الكيك بسهولة. حاسبة تحويل مقاسات قوالب الكيك تساعدك في معرفة حجم القالب المناسب بناءً على المقاسات المختلفة، سواء كنت تستخدم قالبًا دائريًا، مربعًا، أو مستطيلًا.",
    showMain: true,
  },
  // perfect-pancake
  {
    name: "حاسبة البان كيك المثالي",
    link: "/calculator/ar/perfect-pancake/",
    description:
      "احصل على وصفة البان كيك المثالي بناءً على عدد الحصص التي ترغب في إعدادها. حاسبة البان كيك المثالي تساعدك في تحديد كمية المكونات اللازمة مثل الدقيق، الحليب، البيض، والسكر لتحقيق نتائج لذيذة ومثالية.",
    showMain: true,
  },
  // grams-to-cups
  {
    name: "حاسبة تحويل الغرامات إلى أكواب",
    link: "/calculator/ar/grams-to-cups/",
    description:
      "احسب تحويل الغرامات إلى أكواب بسهولة. حاسبة تحويل الغرامات إلى أكواب تساعدك في معرفة كمية المكونات التي تحتاجها بناءً على الوزن، مما يسهل عليك إعداد وصفاتك المفضلة بدقة.",
    showMain: true,
  },
  {
    name: "حاسبة القيمة الغذائية للطعام",
    link: "/calculator/ar/food-nutrients-calculator/",
    description:
      "احسب القيمة الغذائية للطعام بسهولة. حاسبة القيمة الغذائية للطعام تساعدك في معرفة كمية السعرات الحرارية، البروتين، الدهون، والكربوهيدرات في وجباتك المفضلة، مما يساعدك في اتخاذ قرارات غذائية صحية.",
    showMain: true,
  },
  // cooking-measurement
  {
    name: "حاسبة تحويل مقاييس الطهي",
    link: "/calculator/ar/cooking-measurement/",
    description:
      "احسب تحويل مقاييس الطهي بسهولة. حاسبة تحويل مقاييس الطهي تساعدك في معرفة كمية المكونات التي تحتاجها بناءً على وحدات القياس المختلفة، مما يسهل عليك إعداد وصفاتك المفضلة بدقة.",
    showMain: true,
  },
  // chocolate-calculator
  {
    name: "حاسبة الشوكولاتة",
    link: "/calculator/ar/chocolate-calculator/",
    description:
      "احسب كمية الشوكولاتة اللازمة لصنع الحلويات اللذيذة. حاسبة الشوكولاتة تساعدك في تحديد كمية الشوكولاتة المطلوبة بناءً على عدد الحصص التي ترغب في إعدادها، مما يسهل عليك تحقيق نتائج لذيذة ومثالية.",
  },
  // donut
  {
    name: "حاسبة الدونات",
    link: "/calculator/ar/donut/",
    description:
      "احسب كمية المكونات اللازمة لصنع الدونات اللذيذة في المنزل. حاسبة الدونات تساعدك في تحديد كمية الدقيق، السكر، الخميرة، والملح المطلوبة بناءً على عدد الحصص التي ترغب في إعدادها.",
  },

];
export default foodCalculators;